import React, { useEffect, useState } from "react";

import { Tabs } from "src/base-components/Tabs";
import { ExploreTables } from "src/featureCatalogue/Queries/Create/ExploreTables";
import { ColumnType } from "src/featureCatalogue/Queries/Create/helpers";
import { SQLResponsePreview } from "src/featureCatalogue/Queries/Create/SQLResponsePreview";
import { UseFeatureQueryPreview } from "src/featureCatalogue/queries";

enum TabKeys {
  SQL_RESPONSE = "sql-response",
  EXPLORE_TABLES = "explore-tables",
}

export const FeatureQueryPreview: React.FC<{
  previewMutation: UseFeatureQueryPreview;
  columnTypes: Record<string, ColumnType>;
  onColumnTypeChange: (column: string, type: ColumnType) => void;
}> = ({ previewMutation, columnTypes, onColumnTypeChange }) => {
  const [activeTab, setActiveTab] = useState<TabKeys>(TabKeys.SQL_RESPONSE);

  useEffect(() => {
    if (previewMutation.isPending || previewMutation.isSuccess) {
      setActiveTab(TabKeys.SQL_RESPONSE);
    }
  }, [previewMutation.isPending, previewMutation.isSuccess]);

  return (
    <Tabs
      containerClassName="h-full min-h-0 flex flex-col"
      panelClassName="h-full"
      panelsClassName="flex-1 min-h-0"
      selectedKey={activeTab}
      tabListClassName="border-b border-gray-200 mb-6 -top-5 z-10"
      tabs={[
        {
          key: TabKeys.SQL_RESPONSE,
          label: "SQL response",
          content: (
            <SQLResponsePreview
              columnTypes={columnTypes}
              featurePreview={previewMutation}
              onColumnTypeChange={onColumnTypeChange}
            />
          ),
        },
        {
          key: TabKeys.EXPLORE_TABLES,
          label: "Explore",
          content: <ExploreTables />,
        },
      ]}
      onChange={(key) => setActiveTab(key as TabKeys)}
    />
  );
};
